import { nextTick } from 'vue';

function downFontSize(element: HTMLElement, minFontSize: number) {
    const isVerticalScroll = element.scrollHeight > element.clientHeight;
    const isHorizontalScroll = element.scrollWidth > element.clientWidth;

    if (!isVerticalScroll && !isHorizontalScroll) {
        return;
    }

    const fontSize = getComputedStyle(element).fontSize.replace('px', '');
    element.style.fontSize = `${Number(fontSize) - 1}px`;

    // 자식 요소 fontSize도 줄임
    Array.from(element.children).forEach((child) => {
        if (child instanceof HTMLElement) {
            const childFontSize = getComputedStyle(child).fontSize.replace('px', '');
            child.style.fontSize = `${Number(childFontSize) - 1}px`;
        }
    });
    if (Number(fontSize) - 1 <= minFontSize) {
        return;
    }

    nextTick(() => {
        downFontSize(element, minFontSize);
    });
}

export const textFit = (el: HTMLElement, minFontSize = 10) => {
    downFontSize(el, minFontSize);
};

export const textFitDirective = {
    mounted(el: HTMLElement) {
        textFit(el);
    },
};
